
import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  Modal,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { BASE_URL } from "../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import mapicon from "../../../assets/Dashboard/mapicon.svg";  // Added
import empty from "../../../assets/empty.png";
import { useTranslation } from "react-i18next";
const WorkerDailyPerformance = ({ dateRange }) => {
  const { company } = useSelector((state) => state.auth);
  const companyId = company?.id;
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const {t} =useTranslation()
  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
//   const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [tempFilter, setTempFilter] = useState({
    startDate: "",
    endDate: "",
    worker: "",
  });
const [tempWorker, setTempWorker] = useState("");
  const [openSummaryModal, setOpenSummaryModal] = useState(false); // Added

  // helper to get month range
  const getCurrentMonthRange = () => {
    const now = new Date();
    const first = new Date(now.getFullYear(), now.getMonth(), 1);
    const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const formatLocal = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };
    return { startDate: formatLocal(first), endDate: formatLocal(last) };
  };

  // fetch workers list
  const fetchWorkers = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/public/workers?company_id=${companyId}&no_pagination=true`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await res.json();
      const workerList = data.data?.records || [];
      if (workerList.length > 0) {
        setWorkers(workerList);
        return workerList;
      } else {
        console.error("No workers found or invalid response:", data.message);
        return [];
      }
    } catch (e) {
      console.error("Error fetching workers:", e);
      return [];
    }
  };

  // fetch report
  const fetchReport = async (start, end, workerId) => {
    try {
      const res = await fetch(`${BASE_URL}/public/reports/generate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "worker_daily",
          startDate: start,
          endDate: end,
          workerId,
          companyId,
          showChartData: true,
        }),
      });
      const data = await res.json();
      if (!data.error && Array.isArray(data.data?.data)) {
        const chartData = data.data.data.map((d) => ({
          date: new Date(d.report_date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
          }),
          compliance: parseFloat(d.compliance_percentage) || 0,
          productivity: parseFloat(d.productivity_percentage) || 0,
          efficiency: parseFloat(d.efficiency_percentage) || 0,
        }));
        setReportData(chartData);
      } else setReportData([]);
    } catch (e) {
      console.error("Error fetching worker report:", e);
    }
  };




useEffect(() => {
  const init = async () => {
    if (!companyId || !dateRange.startDate || !dateRange.endDate) return;

    const list = await fetchWorkers();

    if (list?.length > 0) {
      const first = String(list[0].id);
      setWorkers(list);
      setSelectedWorker((prev) => prev || first);   // ✅ ensures worker shows
      setTempWorker(first);
      setTempFilter({
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        worker: first,
      });
      fetchReport(dateRange.startDate, dateRange.endDate, first);
    }
  };

  init();
}, [companyId, dateRange]);
// ✅ ensure selectedWorker initializes after workers are fetched
useEffect(() => {
  if (
    workers.length > 0 &&
    !selectedWorker &&
    dateRange.startDate &&
    dateRange.endDate
  ) {
    const first = String(workers[0].id);
    setSelectedWorker(first);
    setTempWorker(first);
    setTempFilter({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      worker: first,
    });
    fetchReport(dateRange.startDate, dateRange.endDate, first);
  }
}, [workers, selectedWorker, dateRange]);



const handleApply = async () => {
  setOpenModal(false);
  setSelectedWorker(tempFilter.worker);
  setIsFiltered(true);
  fetchReport(dateRange.startDate, dateRange.endDate, tempFilter.worker);
};
const handleClearFilter = () => {
  if (workers.length > 0) {
    setSelectedWorker(workers[0]?.id || null);
    setIsFiltered(false);
    fetchReport(dateRange.startDate, dateRange.endDate, workers[0]?.id);
  }
};
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };
useEffect(() => {
  console.log("Workers:", workers);
  console.log("SelectedWorker:", selectedWorker);
  console.log("TempWorker:", tempWorker);
}, [workers, selectedWorker, tempWorker]);
  if (!reportData)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="70vh">
        <CircularProgress />
      </Box>
    );

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
            }}
          >
           {t("reportsScreen.workerDailyTitle")}
          </CustomText>
        
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              border: "1px solid #C4C4C4",
              borderRadius: 1,
              px: 2,
              py: 0.8,
              bgcolor: "#F9FAFB",
              color: "#003149",
              fontSize: 14,
              minWidth: 260,
              textAlign: "center",
            }}
          >
           

{workers.length === 0
  ? `Loading worker... | ${formatDate(dateRange.startDate)} – ${formatDate(dateRange.endDate)}`
  : (() => {
      const active = workers.find((w) => String(w.id) === String(selectedWorker));
      return active
        ? `${active.first_name || ""} ${active.last_name || ""} (${active.email || "no email"}) | 
           ${formatDate(dateRange.startDate)} – ${formatDate(dateRange.endDate)}`
        : `Loading worker... | ${formatDate(dateRange.startDate)} – ${formatDate(dateRange.endDate)}`;
    })()}

          </Box>
<Box
  sx={{
    position: "relative",
    width: 36,
    height: 36,
    borderRadius: 1,
    border: "1px solid #C4C4C4",
    bgcolor: isFiltered ? "#1976d2" : "transparent",
    color: isFiltered ? "#fff" : "#003149",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <IconButton
    onClick={() => {
      setTempWorker(selectedWorker);
       // ✅ ensures always a valid selection

      setOpenModal(true);
    }}
    sx={{
      width: "100%",
      height: "100%",
      color: "inherit",
      "&:hover": {
        backgroundColor: isFiltered ? "#1565c0" : "#1976d220",
      },
    }}
  >
    <FilterAltIcon />
  </IconButton>

  {isFiltered && (
    <IconButton
      size="small"
      onClick={handleClearFilter}
      sx={{
        position: "absolute",
        top: "-5px",
        right: "-5px",
        backgroundColor: "#fff",
        border: "1px solid #C4C4C4",
        width: 18,
        height: 18,
        "&:hover": { backgroundColor: "#f5f5f5" },
      }}
    >
      <CloseIcon sx={{ fontSize: 13, color: "#333" }} />
    </IconButton>
  )}
</Box>
        
        </Box>
      </Box>

      {/* Chart */}
      <Card
        sx={{
          p: 2,
          border: "2px solid #091E4224",
          borderRadius: 2,
          boxShadow: "none",
        }}
      >
       
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Typography      variant="h6"
      sx={{
        fontSize: "15px",
        color: "#44546F",
        fontWeight: 500,
        fontFamily: "Poppins, sans-serif",
      }}>
            {t("reportsScreen.employee_task_day_productivity_efficiency_report")}
            </Typography>
         <IconButton onClick={() => setOpenSummaryModal(true)}>
            <img src={mapicon} alt="map" style={{ width: 33, height: 33 }} />
          </IconButton>
          </Box>
        {reportData.length > 0 ? (
          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={reportData}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="compliance"
                stroke="#1976d2"
                dot={false}
                name={t("reportsScreen.compliance")}
              />
              <Line
                type="monotone"
                dataKey="productivity"
                stroke="#66BB6A"
                dot={false}
                name={t("reportsScreen.productivity")}
              />
              <Line
                type="monotone"
                dataKey="efficiency"
                stroke="#FFA726"
                dot={false}
                name={t("reportsScreen.efficiency")}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <Box height={320} display="flex" alignItems="center" justifyContent="center">
            <img src={empty} alt="No data" style={{ width: 180, opacity: 0.7 }} />
          </Box>
        )}
      </Card>

      {/* Filter Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: 550,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#003149" }}>
          {t("reportsScreen.filterByDateWorker")}
            </Typography>
            <IconButton onClick={() => setOpenModal(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <label className="field_label" style={{ marginTop: "16px" }}>
           {t("reportsScreen.worker")}
          </label>
          <Select
            value={tempFilter.worker}
    
            onChange={(e) => setTempFilter((p) => ({ ...p, worker: e.target.value }))}
            fullWidth
            sx={{
              mt: 1,
              height: "42px",
              fontSize: "15px",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {workers.map((w) => (
              <MenuItem
                key={w.id}
                value={w.id}
                sx={{ fontSize: "13px", fontFamily: "Poppins, sans-serif" }}
              >
                {`${w.first_name || ""} ${w.last_name || ""} (${w.email || "no email"})`}
              </MenuItem>
            ))}
          </Select>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CustomButton label={t("reportsScreen.apply")} size="medium" onClick={handleApply} />
          </Box>
        </Box>
      </Modal>

      {/* Summary Modal */}
      <Modal open={openSummaryModal} onClose={() => setOpenSummaryModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            width: 600,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#003149",
                fontFamily: "Poppins, sans-serif",
              }}
            >
            {t("reportsScreen.summaryData")}
            </Typography>
            <IconButton onClick={() => setOpenSummaryModal(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          {reportData.length > 0 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: "Poppins, sans-serif",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                  <th style={{ padding: "10px" }}>{t("reportsScreen.date")}</th>
                  <th style={{ padding: "10px", textAlign: "right" }}>{t("reportsScreen.compliance")}</th>
                  <th style={{ padding: "10px", textAlign: "right" }}>{t("reportsScreen.productivity")}</th>
                  <th style={{ padding: "10px", textAlign: "right" }}>{t("reportsScreen.efficiency")}</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((d, i) => (
                  <tr key={i}>
                    <td style={{ padding: "8px 10px", borderBottom: "1px solid #eee" }}>
                      {d.date}
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        borderBottom: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {d.compliance}%
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        borderBottom: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {d.productivity}%
                    </td>
                    <td
                      style={{
                        padding: "8px 10px",
                        borderBottom: "1px solid #eee",
                        textAlign: "right",
                      }}
                    >
                      {d.efficiency}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Typography sx={{fontSize:"15px",textAlign:"center",      fontFamily: 'Poppins, sans-serif',}}>{t("reportsScreen.noData")}</Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default WorkerDailyPerformance;
